<template>
  <p>
    <span
      @click="gtmPhoneCallTrigger($event, 'Header - Top bar')"
      v-html="phoneNumberLink"
    />
    <span class="header-top-bar__phone-text" v-html="texts.alwaysAvailable" />
  </p>
</template>

<script>
import { usePhoneNumber } from 'Main/composables/usePhoneNumber';

export default {
  name: 'LocalContactInfo',

  setup() {
    const {
      phoneNumber,
      phoneNumberTel,
      hidePhoneNumber,
      isTherapyPage,
      countryPhoneCode,
      maybeUpdatePhoneNumber,
      updatePhoneNumber,
      ctmRunNow,
      ctmInit,
      gtmPhoneCallTrigger,
    } = usePhoneNumber();
    return {
      phoneNumber,
      phoneNumberTel,
      hidePhoneNumber,
      isTherapyPage,
      countryPhoneCode,
      maybeUpdatePhoneNumber,
      updatePhoneNumber,
      ctmRunNow,
      ctmInit,
      gtmPhoneCallTrigger,
    };
  },

  data() {
    return {
      texts: theme_vars.contactTexts,
    };
  },

  mounted() {
    if (!this.isTherapyPage) {
      window.addEventListener(
        'city-storage-updated-event',
        this.maybeUpdatePhoneNumber,
      );
      this.maybeUpdatePhoneNumber();
    }
  },

  beforeUnmount() {
    window.removeEventListener(
      'city-storage-updated-event',
      this.maybeUpdatePhoneNumber,
    );
  },

  computed: {
    phoneNumberLink() {
      return `<a href="${this.phoneNumberTel}">${this.phoneNumber}</a>`;
    },
  },
};
</script>
